/**
 * Куда вернуть после входа, если человек пришёл по платёжной ссылке
 * (`/buy/<код>`) без входа. Путь живёт в этом браузере сутки: регистрация и
 * подтверждение почты по ссылке из письма проходят в другой вкладке, а вход
 * после них должен привести на оплату, а не на главную.
 *
 * Запоминаются только платёжные ссылки: обычные страницы после входа
 * открываются как раньше — с главной.
 */

const KEY = 'creativitas.returnTo';
const TTL_MS = 24 * 60 * 60 * 1000;

const isBuyPath = (path: string) => /^\/buy\/[^/?#]+$/.test(path);

export function rememberReturnTo(path: string): void {
  if (!isBuyPath(path)) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    /* хранилище недоступно — после входа откроется главная */
  }
}

/** Запомненный путь, если он ещё действует; не стирает его. */
export function pendingReturnTo(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as { path?: unknown; at?: unknown };
    if (typeof saved.path !== 'string' || typeof saved.at !== 'number' || !isBuyPath(saved.path)) return null;
    return Date.now() - saved.at <= TTL_MS ? saved.path : null;
  } catch {
    return null;
  }
}

/** Забыть путь — когда человек дошёл до оплаты. Возвращает, что было запомнено. */
export function takeReturnTo(): string | null {
  const path = pendingReturnTo();
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* нечего стирать */
  }
  return path;
}
